import { CdnImage, Icon } from "@trueskin-web/components"

import verifiedUserIcon from "../images/verified-user.svg"

const PlanDetails = ({
  planId,
  title,
  image,
  description,
  details,
  voucher,
  footnote,
  className,
}) => (
  <div
    sx={{
      overflow: "hidden",
    }}
    className={className}
  >
    {planId.includes("prescription") && description && (
      <div
        sx={{
          textAlign: "right",
          fontSize: 0,
          lineHeight: 2,
          color: "disabled",
        }}
      >
        {description}
      </div>
    )}

    {image ? (
      <div
        sx={{
          position: "relative",
          my: 3,
        }}
      >
        <CdnImage
          src={image}
          alt={title}
          data-testid="web-portal-plan-selection-plan-block-image"
          sx={{
            width: "100%",
            borderRadius: "4px",
          }}
        />
        {voucher && (
          <div
            sx={{
              position: "absolute",
              top: 3,
              right: 3,
              py: 1,
              px: 2,
              fontSize: 0,
              fontWeight: "bold",
              lineHeight: 1.4,
              borderRadius: "4px",
              background: "notification",
            }}
          >
            {voucher}
          </div>
        )}
      </div>
    ) : null}

    <div
      sx={{
        mt: 2,
        display: "flex",
        flexDirection: "column",
        rowGap: 4,
        lineHeight: "smallerHeading",
      }}
    >
      {details.map((item, index) => (
        <div
          key={index}
          sx={{
            display: "inline-flex",
            columnGap: 1,
            fontSize: 1,
          }}
        >
          <Icon
            icon={item.icon}
            size="sm"
            color={item.theme}
            sx={{ mt: "2px", flexShrink: 0, transform: "scale(1.125)" }}
          />
          {item.content}
        </div>
      ))}
    </div>

    {footnote && (
      <div
        data-component-name="PlanFootnote"
        sx={{
          mt: 4,
          py: "13px",
          px: 3,
          display: "flex",
          alignItems: "center",
          gap: 1,
          fontSize: 1,
          lineHeight: "heading",
          color: "#0B1770",
          background: "brandPrimaryUltraLight",
          borderRadius: "8px",
        }}
      >
        <Icon icon={verifiedUserIcon} size="sm" />
        {footnote}
      </div>
    )}
  </div>
)

export default PlanDetails
